import styled, { css } from 'styled-components'

import { themeHelpers } from '@gotamedia/fluffy/theme'
import FluffySlider from '@gotamedia/fluffy/Slider'


const SliderContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

const Slider = styled(FluffySlider)<{width: number, legacy?: boolean}>`
    height: ${({ legacy }) => legacy ? 256 : 196}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`height: ${legacy ? 190 : 216}px;`)};
    width: ${({ width }) => `${width}px`};
    margin: auto;
    ${themeHelpers.isSmallDevice(css`
        width: 100vw;
    `)};
`

const CardWrapper = styled.div<{width?: number, legacy?: boolean}>`
    display: flex;
    flex-direction: column;
    height: ${({ legacy }) => legacy ? 221 : 162}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 181px;"}`)};
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "width: 300px;"}`)};
    min-width: 170px;
    max-width: ${({ legacy }) => legacy ? 200 : 300}px;
    box-shadow: 0px 2px 4px rgba(46, 42, 37, 0.12);
    background: #fff;
    margin: 6px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`
        height: ${legacy ? 155 : 181}px;
        ${legacy ? "" : "width: 300px;"};
        min-width: auto;
        max-width: auto;
    `)}
    ${(props) => props.width === undefined ? undefined : css`
        width: ${props.width}px;
        margin-right: 10px;
    `}
`

const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const CardImage = styled.img<{legacy?: boolean}>`
    width: 164px;
    height: 77px;
    aspect-ratio: 2/1;
    object-fit: contain;
    padding: 10px;
    margin-top: 15px;
    margin-bottom: 15px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`
        height: ${legacy ? 57 : 100}px;
        ${legacy ? "" : "margin: 0;"}
    `)};
`

const CardName = styled.span`
    height: 100%;
    font-size: 14px;
    font-family: "Sanomat Sans Text";
    text-align: center;
    font-weight: 700;
    padding-right: 10px; 
    padding-left: 10px; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    max-height: 46px;
    -webkit-box-orient: vertical;
`

const Wrapper = styled.div`
    height: 120px;
`

const StyledNavigation = styled(Slider.Navigation)`

`

export {
    Slider,
    SliderContainer,
    StyledNavigation,
    CardWrapper,
    CardContainer,
    CardImage,
    CardName,
    Wrapper
}
